module.exports = __webpack_public_path__ + "static/assets/3e3698d8783d6f7d5350e53b9ad370b3.png";